export default __webpack_public_path__ + "images/EU.bfad3ec.png";